jQuery(document).ready(function ($) {

  // Responsive Videos
  $('main').responsivevideos();

  // Tabs
  $('main').tabs({
    dropdown: true,
    desktop: 1025,
    animated: true
  });

  // Accordions
  // $('main').accordions();

  // Form Labels
  formLabels();

  // Format Phone Numbers
  $('[itemprop="telephone"]').each(function () {
    var number = $(this).text();
    var formattedNumber = number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    $(this).wrapInner('<a href="tel:' + formattedNumber + '"></a>');
  });

  //View More for Alternative Accordions List

  function gatherAltAccordions() {
    var r = $.Deferred();
    $(':not(.accordion-alt-item) + .accordion-alt-item, * > .accordion-alt-item:first-of-type').each(function () {
      $(this).nextUntil(':not(.accordion-alt-item)').addBack().wrapAll('<div class="accordions-alt-list active" />');
    });
    return r;
  }

  function accordionAltButton() {
    var r = $.Deferred();
    $('.accordions-alt-list .accordion-alt-item .description').each(function () {
      $(this).append('<a class="read-more" tabindex="0">View More <span class="fa fa-caret-down"></span></a>')
    });


    $('.accordion-alt-item .read-more').click(function () {
      var $more = $(this).closest('.accordion-alt-item');
      var $toggletext = $(this).closest('.accordion-alt-item .read-more');

      if ($more.hasClass('expanded')) {
        $more.removeClass('expanded');
        $toggletext.html('View More <span class="fa fa-caret-down"></span>');
      } else {
        $more.addClass('expanded');
        $toggletext.html('View Less <span class="fa fa-caret-up"></span>');
      }
    });

    $('.accordion-alt-item .read-more').on('keypress', function (e) {
      if (e.which === 13) {
        var $more = $(this).closest('.accordion-alt-item');
        var $toggletext = $(this).closest('.accordion-alt-item .read-more');

        if ($more.hasClass('expanded')) {
          $more.removeClass('expanded');
          $toggletext.html('View More <span class="fa fa-caret-down"></span>');
        } else {
          $more.addClass('expanded');
          $toggletext.html('View Less <span class="fa fa-caret-up"></span>');
        }
      }
    });
    return r;
  }

  gatherAltAccordions().done(accordionAltButton());
  //View More for Alternative Accordions List - END

  //If subnavigation has no items, then remove
  if ($('.subnavigation ul li').length <= 1) {
    $('.subnavigation').remove();
  }
  //If subnavigation has no items, then remove - END

  //If breadcrumb has 1 or less items, then remove
  if ($('.breadcrumbs-container ul li').length <= 1) {
    $('.breadcrumbs-container').remove();
  }
  //If breadcrumb has 1 or less items, then remove - END

  //If pager has 1 or less page, then remove
  if ($('.pager .page').length <= 1) {
    $('.page').remove();
  }
  //If pager has 1 or less items, then remove - END


  //Subnav Functionality - START
  $('.subnavigation span.more').on('click', function () {
    $('.subnavigation').toggleClass('active');
  });

  $('.subnavigation span.more').on('keypress', function (e) {
    if (e.which === 13) {
      $('.subnavigation').toggleClass('active');
      $('.subnavigation ul li a:last').on('focusout', function () {
        $('.subnavigation.active').removeClass('active');
      });
    }
  });

  //Switch out News Details heading with News Headline
  $(document).ready(function () {
    $(".subpage-title h1").html($('.news-detail-headline').html());
    $('.news-detail-headline').remove();
  });

});

// Form Labels
function formLabels() {
  // Forms
  $('input:not([type="radio"]):not([type="checkbox"]), textarea, select').focus(function () {
    $(this).parent('div').addClass('focused');
  });

  $('input:not([type="radio"]):not([type="checkbox"]), textarea, select').blur(function () {
    var inputValue = $(this).val();
    // console.log(inputValue);
    if (inputValue === '') {
      $(this).parent('div').removeClass('focused');
    }
  });
  // File Upload
  $('input[type="file"]').each(function () {
    $(this).next('label').after('<span class="file"></span>');
    $(this).on('change', function () {
      var filePath = $(this).val();
      var splitFilePath = filePath.split('\\');
      var fileName = splitFilePath[splitFilePath.length - 1];
      var file = $(this).closest('div').find('.file');
      if (filePath.length === 0) {
      } else {
        file.text(fileName);
      }
    });
  });

  $('.content-section').each(function () {
    if ($(this).text().trim().length == 0) {
      $(this).hide();
    }
  });
}
// Fires Functions on Partial Postback and Page Load
function pageLoad() {
  formLabels();
}